import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { ShieldCheck } from 'phosphor-react';

const DISCLAIMER_KEY = 'bridge_builder_disclaimer_accepted';

const DISCLAIMER_TEXT = `This tool provides a rough estimate for preliminary planning and budgetary purposes only. All values are approximate and subject to change based on design development, member sizing, spacing, connection details, and project-specific requirements. This is not a formal quotation and should not be relied upon for final costing. Firm pricing must be obtained through an official quotation based on complete drawings and current material pricing at the time of request.`;

export function DisclaimerModal({ forceOpen = false, onClose }) {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (forceOpen) {
      setOpen(true);
    }
  }, [forceOpen]);

  const handleAccept = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  const handleOpenChange = (val) => {
    if (!val && forceOpen) {
      setOpen(false);
      if (onClose) onClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="bg-slate-800 border-slate-600 text-slate-100 max-w-lg"
        onPointerDownOutside={(e) => {
          if (!forceOpen) e.preventDefault();
        }}
        onEscapeKeyDown={(e) => {
          if (!forceOpen) e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl text-slate-100">
            <ShieldCheck className="w-6 h-6 text-blue-400" weight="fill" />
            Important Disclaimer
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-5">
          <p className="text-slate-300 text-sm leading-relaxed">
            {DISCLAIMER_TEXT}
          </p>
          <Button
            data-testid="disclaimer-accept-btn"
            onClick={handleAccept}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3"
          >
            I Understand
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function DisclaimerFooter({ onClick }) {
  return (
    <footer className="w-full py-4 mt-6">
      <div className="container mx-auto px-6">
        <button
          data-testid="disclaimer-footer-link"
          onClick={onClick}
          className="w-full text-center text-xs text-slate-400/80 hover:text-blue-400 transition-colors cursor-pointer underline underline-offset-2 decoration-slate-500/40 hover:decoration-blue-400/60"
        >
          Disclaimer: This tool provides rough estimates for budgetary purposes only. Click to read full disclaimer.
        </button>
      </div>
    </footer>
  );
}
